import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Stethoscope, Send, MessageCircle } from 'lucide-react';
import { NAV, CLINIC } from '../mock';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await axios.post(`${API}/subscribers`, { email });
      setDone('Thanks! You are subscribed.');
      setEmail('');
    } catch (err) {
      if (err?.response?.status === 409) {
        setDone('You are already subscribed.');
        setEmail('');
      } else {
        setDone('Could not subscribe. Please try again.');
      }
    }
    setTimeout(() => setDone(''), 4000);
  };

  return (
    <footer className="deep-section text-teal-50">
      <div className="container-x py-16">
        <div className="grid gap-12 lg:grid-cols-4 md:grid-cols-2">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="grid place-items-center w-11 h-11 rounded-xl bg-white/10"><Stethoscope size={22} /></span>
              <span className="font-display text-xl">Srigyan Clinic</span>
            </div>
            <p className="text-teal-100/80 text-sm leading-relaxed">Personalised, evidence-based care for arthritis, autoimmune and metabolic bone diseases — bringing UK consultant-level rheumatology to Delhi NCR.</p>
            <a href={CLINIC.mapCid} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-5 text-sm text-teal-200 hover:text-white transition-colors">
              <Facebook size={18} /> Follow us on Facebook
            </a>
          </div>

          <div>
            <h4 className="font-display text-lg mb-5">Explore</h4>
            <ul className="space-y-2.5 text-sm">
              {[...NAV.slice(0, 6), ...NAV.slice(-2)].map((n) => (
                <li key={n.to}><Link to={n.to} className="text-teal-100/80 hover:text-white transition-colors">{n.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg mb-5">Get in touch</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex gap-3"><MapPin size={18} className="shrink-0 text-teal-300" /><span className="text-teal-100/80">{CLINIC.address}</span></li>
              <li className="flex gap-3"><Phone size={18} className="shrink-0 text-teal-300" /><a href={`tel:${CLINIC.phoneRaw}`} className="text-teal-100/80 hover:text-white">{CLINIC.phone}</a></li>
              <li className="flex gap-3"><Mail size={18} className="shrink-0 text-teal-300" /><a data-testid="footer-email-link" href={`mailto:${CLINIC.email}`} className="text-teal-100/80 hover:text-white transition-colors break-all">{CLINIC.email}</a></li>
            </ul>
            <a href={CLINIC.whatsapp} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-5 bg-white/10 hover:bg-white/20 transition-colors px-4 py-2.5 rounded-full text-sm font-medium">
              <MessageCircle size={16} /> Message on WhatsApp
            </a>
          </div>

          <div>
            <h4 className="font-display text-lg mb-5">Subscribe</h4>
            <p className="text-teal-100/80 text-sm mb-4">Sign up for clinic updates and patient education.</p>
            <form onSubmit={submit} className="flex bg-white/10 rounded-full p-1.5">
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required placeholder="Your email" className="flex-1 bg-transparent px-4 text-sm outline-none placeholder:text-teal-200/60 text-white" />
              <button type="submit" className="btn-coral grid place-items-center w-10 h-10 rounded-full shrink-0"><Send size={16} /></button>
            </form>
            {done && <p className="text-teal-200 text-xs mt-2">{done}</p>}
          </div>
        </div>

        <div className="border-t border-white/10 mt-14 pt-6 pb-24 md:pb-0 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-teal-200/70">
          <p>© {new Date().getFullYear()} Srigyan Rheumatology Clinic — All Rights Reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/login" className="hover:text-white transition-colors">Staff Login</Link>
            <span>Noida / Ghaziabad</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
